import { ReactElement, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BigBanner from '../../components/BigBanner';
import { Button } from '../../components/Button';
import { PageHelmet } from '../../components/PageHelmet';
import FaleConoscoForm from './FaleConoscoForm';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { useForm } from 'react-hook-form';
import { Input } from '../../components/Input';
import axios from 'axios';
import WhatsApp from '../../components/BotWhatsApp/whatsApp';

// Aceita 000.000.000-00 ou 00000000000
//const cpfRegex = /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/;
//const cpfRegex = /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/;

/* const validacaoCpf = z
  .object({
    isClient: z.coerce.boolean(),
    cpf: z.string().regex(cpfRegex, { message: 'CPF inválido' }).optional(),
  })
  .refine(data => !data.isClient || !!data.cpf, {
    path: ['cpf'],
    message: 'CPF é obrigatório quando “Sim”',
  });

type FormData = z.infer<typeof validacaoCpf>;
 */
const Formulario = () => {
  const [isClient, setIsClient] = useState<boolean | null>(null);

  const [perfil, setPerfil] = useState<string | null>(null);

  const opcoes = [
    { value: 'beneficiario', label: 'Já sou Beneficiário' },
    { value: 'nao-beneficiario', label: 'Não sou Beneficiário' },
    { value: 'empresa', label: 'Sou Prestador Empresa' },
    { value: 'vendedor', label: 'Sou Vendedor' },
    { value: 'dentista', label: 'Sou Prestador Dentista' },
    { value: 'corretora', label: 'Sou Parceiro Corretora' },
    { value: 'clinica', label: 'Sou Cliente Clínica' },
  ];

  return (
    <div className="mb-4 flex flex-col items-center gap-4">
      <div className="bg-white p-4 w-full rounded">
        <form className="w-full ">
          <div className="mb-4 flex flex-col items-center gap-4">
            <div className="bg-white p-4 w-full rounded">
              {perfil === null && (
                <div className="mb-4 p-1">
                  <p className="text-gray-600 text-lg sm:text-2xl p-2 mb-5">
                    Selecione seu perfil:
                  </p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {opcoes.map(opcao => (
                      <label
                        key={opcao.value}
                        className="flex items-center gap-2 text-blue-700 text-sm md:text-xl cursor-pointer"
                      >
                        <input
                          type="radio"
                          name="perfil"
                          checked={perfil === opcao.value}
                          onChange={() => setPerfil(opcao.value)}
                          className="w-4 h-4"
                        />
                        {opcao.label}
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {/* WhatsApp se beneficiário OU não beneficiário */}
              {(perfil === 'beneficiario' || perfil === 'nao-beneficiario') && (
                <div className="p-3 sm:p-5 text-center">
                  <p className="text-blue-500 text-sm sm:text-base md:text-lg">
                    Seja bem-vindo (a) ao nosso canal de Atendimento.
                  </p>
                  <div className="mt-4 sm:mt-6">
                    <WhatsApp phone="55556184280128" />
                  </div>
                </div>
              )}

              {/* Formulário se for outro perfil */}
              {perfil &&
                perfil !== 'beneficiario' &&
                perfil !== 'nao-beneficiario' && (
                  <div className="mt-6">
                    <div className="bg-white text-primary-main rounded shadow-card p-8 w-full max-w-[760px] text-left">
                      {/* <FaleConoscoForm /> */}
                      <FaleConoscoForm perfilSelecionado={perfil} />
                    </div>
                  </div>
                )}
            </div>
          </div>

          {/* {isClient && !cpfValido && (
            <div>
              <p className="text-gray-600 text-sm sm:text-base">
                Digite seu CPF para validarmos sua inscrição:
              </p>
              <Input
                label={''}
                type="text"
                color="black"
                placeholder="000.000.000-00"
                {...register('cpf')}
              />
              {errors.cpf && (
                <p className="text-red-500 text-sm">{errors.cpf.message}</p>
              )}
              <button
                className="bg-blue-500 hover:bg-blue-600 transition text-white px-4 py-2 mt-5 rounded w-full sm:w-auto"
                type="submit"
                disabled={loading}
              >
                Verificar
              </button>
            </div>
          )} */}
          {/* {cpfValido && (
            <div className="p-3 sm:p-5 text-center">
              <p className="text-green-500 pb-2 text-base sm:text-lg md:text-xl">
                CPF validado com sucesso!
              </p>
              <p className="text-green-500 text-sm sm:text-base md:text-lg">
                Seja bem-vindo (a) ao nosso canal de Atendimento.
              </p>
              <div className="mt-4 sm:mt-6">
                <WhatsApp phone="55556184280128" />
              </div>
            </div>
          )} */}
        </form>
        {isClient === false && (
          <div className="mt-6">
            <div className="bg-white text-primary-main rounded shadow-card p-8 w-full max-w-[760px] text-left">
              <FaleConoscoForm perfilSelecionado={perfil} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default function FaleConoscoPage(): ReactElement {
  return (
    <div className="h-full min-h-[calc(100vh-549px)]">
      <PageHelmet title="Fale Conosco | OdontoGroup" />

      <BigBanner
        href="#ouvidoria-form"
        page="ouvidoria"
        mainText={
          <div style={{ textAlign: 'justify' }}>
            Estamos aqui para cuidar do seu sorriso – e te ouvir com atenção.
            <br />
            <span
              style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }}
            >
              Em caso de dúvidas, sugestões ou necessidade de ajuda com o seu
              plano, fale com a gente. Nosso time está pronto para te atender
              com presteza e agilidade.
            </span>
          </div>
        }
      />

      <section className="bg-primary-main text-white px-4 py-16 flex flex-col items-center text-center">
        <div className="max-w-4xl">
          <p className="text-2xl md:text-3xl leading-9 font-light mb-10">
            Agora você, nosso <strong>beneficiário</strong> ou{' '}
            <strong>parceiro</strong>, pode registrar seu “Fale Conosco”
            acessando sua área exclusiva em nosso site.
          </p>

          <p className="text-lg font-light mb-8">
            Clique no botão abaixo que o identifique e entre em contato com a
            nossa equipe:
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=1"
            text="Pessoa Física"
            className="w-fit"
            intent="newOrange"
          />
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=2"
            text="Pessoa Jurídica"
            className="w-fit"
            intent="newOrange"
          />
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=6"
            text="Corretor"
            className="w-fit"
            intent="newOrange"
          />
          <Button
            tag={Link}
            to="https://odontogroup.s4e.com.br/sys/?TipoUsuario=4"
            text="Prestador"
            className="w-fit"
            intent="newOrange"
          />
        </div>
        <div className="max-w-3xl">
          <p className="text-lg font-light mb-6">
            Você também pode entrar em contato conosco através do nosso
            atendimento online.
          </p>
        </div>

        <Formulario />
      </section>

      <section className="bg-primary-main px-6 py-12 text-white text-center flex flex-col items-center">
        <p className="text-2xl md:text-3xl leading-9 font-light max-w-4xl mb-6">
          Ou através do nosso aplicativo. Baixe aqui:
        </p>

        <div className="flex flex-wrap justify-center gap-8 mt-4">
          <a
            className="max-w-[160px]"
            href={process.env.REACT_APP_GOOGLE_PLAY}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/assets/images/google-play-tag.png"
              alt="Google Play"
              className="w-full"
            />
          </a>
          <a
            className="max-w-[160px]"
            href={process.env.REACT_APP_APPLE_STORE}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/assets/images/app-store-tag.png"
              alt="App Store"
              className="w-full"
            />
          </a>
        </div>
      </section>
    </div>
  );
}
function setSelectedDoc(arg0: string) {
  throw new Error('Function not implemented.');
}
function setValue(arg0: string, arg1: string) {
  throw new Error('Function not implemented.');
}
